// extracted by mini-css-extract-plugin
export default {"container":"URKWGBnTaIHaubdEqZbA","description":"l1sQtEv0ZXu1SOeYghkg","title":"nsTyBmg9OKwOMJj7M32u","image":"BjEdVvzWzHkDGkE0r8_q"};